import React, {Component} from 'react';
import {urlFactoryConfig} from '../database/apiUrls'
import SecondServer from '../database/SecondServer'
import ChartModal from '../Chart/ChartModal'
import { TitleRow, newSortIndicators, clickToTableTarget, coreSort } from './RenderHelpers';
import {dateSort} from './helperfunctions'
import NoResults from '../Alert/NoResults';
import DevicePanel from './Controls/DevicePanel';
import DeviceStatusPanel from './Controls/DeviceStatusPanel'
import {CsvButton4} from './Controls/CsvButton3'
import DatePanel3 from './Controls/DatePanel3';
import ChartButton from './Controls/ChartButton';
import TrendButton from './Controls/TrendButton'
import { csvDownload } from '../csv/csvExport';
import {between, sanitizeDateTime, isSameDay, dateOnly} from '../timeFunctions/timeFns'
import MeteringReport from './meteringReport';
import { siteAccessCode, siteTZ } from '../database/apiv2SiteAccessor';
import {consumed, isIgnored, dynCons} from './Consumption'
import {computeReading, chunkyHistory, isComputableReading } from './HistoricalData';
import Rollup from './Controls/Rollup'
import Cookies from "js-cookie";
import {lastDay, lastWeek, lastMonth} from './Controls/PeriodDropDown'
import TrendPanel from './Trend/TrendPanel'
import "./Controls/controls.css"
import "./deviceReadings.css"
import '../Loading/spinload.css'
import { renderLoader } from '../Loading/loading';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faExclamationCircle} from "@fortawesome/free-solid-svg-icons";

export default class DeviceReadings extends Component {
  constructor(props) {
    super(props);
    this.reportId = 'devicereading';
    this.tableId = "dispTable";
    this.cookieId = this.reportId+'rollup'
    const roll = Cookies.get(this.cookieId) ?? 'none'
    this.config = {
      displayOrder: ["renderTime", "ReadVal1", "Consumed1", "ReadVal2", "Consumed2", "ReadVal3", "Consumed3"],
      displayName : ["Date", "Reading 1", "Consumed", "Reading 2", "Consumed", "Reading 3", "Consumed"],}
    this.state = {
      colSort: newSortIndicators(this.config.displayOrder.length),
      lastSort: undefined,
      startrange: this.props.startTime ?? new Date (Date.now() - 24*3600 * 1000),
      endrange: this.props.endTime ?? new Date(),
      modalShow: this.props?.showChart ?? true,
      trendShow: false,
      displayData: null,
      chartData: null,
      chartLabel: null,
      redirecting: false,
      isLoading: false,
      loader: renderLoader(),
      deviceConfig: undefined,
      rollup: roll
    };
    this.decimals = this.precisionFromFactor()
    this.renderChart = this.renderChart.bind(this);
    this.toggleChart = this.toggleChart.bind(this);
    this.setFilters = this.setFilters.bind(this);     // replacement for above
    this.redirecting = this.redirecting.bind(this);
    this.sort = this.sort.bind(this)
    this.onRollup = this.onRollup.bind(this)
  }

  async componentDidMount() {
    this.props.updateSiteLocation("tourDevReadings");
    const ss = new SecondServer(this.props);
    const pledge = ss.apiData(urlFactoryConfig(this.props.deviceId))
    this.setBreadCrumb()
    if (this.props?.deviceData) {
      this.computeDetail(this.props.deviceData)
    }
    else {
      this.fetchData(this.state.startrange, this.state.endrange)
    }
    const cfg = await (pledge)
    if (cfg?.data?.data)
      this.setState({deviceConfig: cfg.data.data})
    // console.log (findTZ(siteTZ(this.props.getActiveSite())))
  }
  async componentDidUpdate(prevProps, prevState) {
    if (this.props?.update && prevProps.update < this.props.update) {   // refresh button
      this.setBreadCrumb()  // parent view can reset
      if (this.props.intervalDropDown < 3) { 
        const intervals = [lastDay, lastWeek, lastMonth]
        const range = intervals[this.props.intervalDropDown]()
        this.setState ({startrange:range[0], endrange: range[1]})
        this.fetchData(range[0], range[1])
      }
    }
  }
  async fetchTimedData (params) {
    if (params.dropDown > 0) {
      this.fetchData (params.start, params.end)
    }
    this.setState ({startrange: params.start, endrange: params.end});  
  }
  async fetchData (sd, ed) {
    this.setState({isLoading: true})
    const radioId = this.props.deviceId
    const siteId = siteAccessCode(this.props.getActiveSite())
    const ss = new SecondServer(this.props);
    const resp = await chunkyHistory(ss, siteId, radioId, sd, ed)

    this.computeDetail (this.mashIntoShape(resp))
    //let arrSort = this.state.displayData
    //arrSort = dateSort(arrSort, "ReadTime")
    //this.setState({displayData: arrSort, isLoading: false})
    this.setState ({isLoading: false})
    //return arrSort
  }
  // make single device api (fetch) look like site api (props)
  mashIntoShape(deref) {
    //const deref = resp?.jsonResponse?.data?.data?.readings
    let result = []
    deref && deref.forEach (item=> {
      const ivals= item.raw_values.map (a => Object.values(a)[0])
      const stype = item.raw_values.map (a => Object.keys(a)[0])
      result.push({DeviceId: this.props.deviceId, ReadTime: item.read_time, RXTime: item.rx_time,
        ReadVal1: this.specialCompute (item, ivals[0], 0),
        NonComp0: !isComputableReading(this.props.deviceConfig, ivals[0], 0),
        ReadVal2: this.specialCompute(item, ivals[1], 1),
        NonComp1: !isComputableReading(this.props.deviceConfig, ivals[1], 1),
        ReadVal3: ivals[2] ?? 0,
        SensorType1: stype[0] ?? 'FF', SensorType2: stype[1] ?? 'FF', SensorType3: stype[2] ?? 'FF'
      }) 
    })
    return result
  }
  specialCompute (item, rawval, index) {
    const config = this.props.deviceConfig
    if (config?.sensors?.length >= index && config.sensors[index]?.sensor_type !== "FF") {
      if (isIgnored(config.sensors[index]?.sensor_type)) 
        return Object.values(item.values[index])[0]
      else
        return computeReading (config, rawval, index) ?? 0
    } 
  }
  setBreadCrumb () {
    this.props.breadCrumb([{display:'Readings', click:this.redirecting}, 
      {display: this.props.deviceId, click:undefined}])
  }
  //click handler for title row
  sort(e) {
    const targ = clickToTableTarget(e);
    //console.log (targ, targ.cellIndex)
    if (!targ?.id)
      return
    if (this.state.lastSort === targ.id) {
      let dir = this.state.colSort
      dir[targ.cellIndex] = dir[targ.cellIndex] === 2 ? 1 : dir[targ.cellIndex]+1;
      this.setState({displayData: this.state.displayData.reverse(), colSort: dir})
    }
    else {
      let dir = new Array(this.state.colSort.length).fill(0);
      dir[targ.cellIndex]++ 
      //console.log (targ.cellIndex)
      let arrSort = this.state.displayData
      if (targ.id === 'renderTime') 
        arrSort = dateSort(arrSort, "ReadTime")
      else 
        coreSort(arrSort,targ.id)
      this.setState({displayData: arrSort, lastSort: targ.id, colSort: dir})
    }
  
  }
  parseFormatFloat(str) {
    const n = parseFloat(str.replace(/,/g, ''))
    return isNaN(n) ? str : n
  }
  numericReadval(arrData) {
    arrData.forEach(item => {
      item.ReadVal1 = typeof item?.ReadVal1 === 'string' ? this.parseFormatFloat(item.ReadVal1) : item?.ReadVal1
      item.ReadVal2 = typeof item?.ReadVal2 === 'string' ? this.parseFormatFloat(item.ReadVal2) : item?.ReadVal2
      item.ReadVal3 = typeof item?.ReadVal3 === 'string' ? this.parseFormatFloat(item.ReadVal3) : item?.ReadVal3
    })
    return arrData
  }
  computeDetail (arrData) {
    const arrWorking = this.consumption(this.numericReadval(arrData.slice(0)));
    arrWorking.reverse()
    this.setStateData (arrWorking)
  }

  consumption (arrData) {
    let byDate = dateSort(arrData, "ReadTime", 0);
    if (Array.isArray(byDate) && byDate.length > 1) {
      for (let index = 1; index < byDate.length; ++index) {
        dynCons (byDate, index)
      }
    }
    return byDate
  }

  setFilters(which, panelState) {
    if (which === 'date') {
      const param = {
        start: panelState?.startTime ?? this.state.startrange,
        end: panelState?.endTime ?? this.state.endrange,
        dropDown: panelState.dropDown 
      }
      this.fetchTimedData(param)
    }
  }
  onRollup (interval) {
    if (interval === 'none')
      this.consumption(this.state.displayData)
    this.setChartData (interval)
    this.setState({rollup:interval})
    Cookies.set(this.cookieId, interval)
  }
  toggleChart(props) {
    this.setState ( {modalShow: !this.state.modalShow});
  }
  toggleTrend = () =>{
    this.setState({trendShow: !this.state.trendShow})
  } 
  getChartProps() {
    const dev = this.props?.deviceData[0]
    return ({
      radioId: this.props.deviceId,
      sensor: 'Sensor 1',
      units: '',
      deviceMeta: this.props?.deviceMeta? this.props.deviceMeta[0] : {},
      sensorType: dev?.SensorType1 ?? 'FF',
      sensorType2: dev?.SensorType2 ??'FF',
      sensorType3: dev?.SensorType3 ?? 'FF',
      data: this.state.chartData,
      label: this.state.chartLabel,
      secondChart: this.state.secondChart,
      thirdChart: this.state.thirdChart,
      apiParams: 'SensorData',
      rollup: this.state.rollup,
      hiddenMap: this.hiddenColMap(this.state.displayData)
    });
  }
  setChartData(interval) {
    this.setStateData(this.state.displayData, interval)
  }
  setStateData(arrWorking, interval=undefined) {
    // let member = this.props?.channel === 2 ? 'ReadVal2' : 'ReadVal1'
    const disp = this.rollup2 (arrWorking, interval)
    let chartdata = [];
    let labeldata = [];
    let secondChart = []
    let thirdChart = []
    disp.forEach((row) => {
      chartdata.push(row.ReadVal1)
      labeldata.push(row.ReadTime)
      secondChart.push(row.ReadVal2)
      thirdChart.push(row?.ReadVal3)
    });
    this.setState({chartData: chartdata, chartLabel: labeldata, secondChart: secondChart, 
          thirdChart: thirdChart, displayData: arrWorking, lastSort:'renderTime'})
  }

  redirecting(){
    this.setState({redirecting: true});
  }

  renderConditionalButtons() {
    if (!this.state.modalShow) {
      return (
        <>
        <CsvButton4 csvClick={csvDownload} csvTable={this.tableId} file={this.props.deviceId}/>
        <span className="btnlabel">Download CSV</span>
        </>
      )
    };
    return null
  }

  renderChart() {
    if (this.state.isLoading)
      return this.state.loader

    const chartProps = this.getChartProps();
    if (chartProps.data === null)
      return null;
    const from = this.state.startrange;
    const until = this.state.endrange
    return (
      <ChartModal show={this.state.modalShow} hide={this.toggleChart} 
        singleBlock={true} chartProps={chartProps}
        startrange={from} endrange={until} {...this.props} noUpdates={true} />
    );
  }

  renderTrend() {
    return (
      <TrendPanel show={this.state.trendShow} hide={this.toggleTrend} 
        {...this.props} report={this.state.displayData} chartProps={this.getChartProps()}
        startrange={this.state.startrange} endrange={this.state.endrange} />
    );
  }
  precisionFromFactor() {
    let result =  [-1, 2, 2, 2, 2, 2, 2]  // [time, reading1, cons1, reading2, cons2, r3, cons3]
    const prec1 = this.props.deviceConfig?.sensors[0]?.factor?.length ?? 2;
    [result[1], result[2]] = [prec1, prec1]
    const prec2 = this.props.deviceConfig?.sensors[1]?.factor?.length ?? 2;
    [result[3], result[4]] = [prec2, prec2]
    const prec3 = this.props.deviceConfig?.sensors[2]?.factor?.length ?? 2;
    [result[5], result[6]] = [prec3, prec3]
    return result
  }
  sanitizeDCVals(dev) {
    let result = dev
    result.ReadVal1 = result?.ReadVal1 === 4294967295 ? "Disconnected" : result?.ReadVal1
    result.ReadVal2 = result?.ReadVal2 === 4294967295 ? "Disconnected" : result?.ReadVal2
    return result
  }
  cellContent (col, value, key) {
    const errMap = {ReadVal1: 'NonComp0', ReadVal2: 'NonComp1', ReadVal3: 'NonComp2'}
    const errDisp = value[errMap[col]] ? 
      <FontAwesomeIcon icon={faExclamationCircle} key={key} size='xs'color='#E74C3C'/> : null
    return <span key={key}>{value[col] ?? ''}&nbsp;{errDisp} </span>
  }
  renderRow (dev, index, colSeq) {
    const readTime = sanitizeDateTime(dev.ReadTime, {zone: 'UTC'})
    if (between (readTime, this.state.startrange, this.state.endrange)) {
      const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute:'numeric' };
      dev.renderTime = readTime.toLocaleDateString("en-US", options).replace(/\//g, "-");
      const disp = this.sanitizeDCVals(dev);
      colSeq.forEach((col, index) => this.decimals[index] > -1 && disp[col] ?
        disp[col] = disp[col].toLocaleString (undefined, { minimumFractionDigits: this.decimals[index]}) :
        ()=>{}
      )
      return (
        <tr className='csv-tr' key={index}>
          {colSeq.map((col, index) => 
          <td className={"csv-td"} id={col} key={col}> 
            {this.cellContent(col, disp, col)}
          </td>
          )}
        </tr>
      );
    }
    return null
  }
/*
        <BodyRow data={disp} colSeq={colSeq} getIcon={null} deco={null} 
        graph={null} batteryFormat={null} key={index} decimals={this.decimals}/>
*/
  hiddenColMap (data) {
    const optCols = [{dataCol: "ReadVal2", depCol: "Consumed2", type: "SensorType2"},
                     {dataCol: "ReadVal3", depCol: "Consumed3", type: "SensorType3"},]
    if (Array.isArray(data)) {
      const show = optCols.map (i => data.some (d => d[i.dataCol] && d[i.type] !== 'FF'))
      const result = this.config.displayOrder.map (i => {
        const findex = optCols.findIndex(fo => i === fo.dataCol || i === fo.depCol)
        return findex > -1 ? show[findex] : true
      })
      return result
    }
    return new Array (this.config.displayOrder.length).fill(true)
  }
  rollup2(data, rollup=undefined) {
    const roll = rollup === undefined ? this.state.rollup : rollup
    if (roll === 'none')
      return data
    const allTimes = data.map(i=>dateOnly(sanitizeDateTime(i.ReadTime, {zone: 'UTC'})).getTime())
    const uniqDates = [...new Set(allTimes)];
    const dtObj = new Date()
    const groups = uniqDates.map (d => {
      dtObj.setTime(d)
      return data.filter(i=> isSameDay(sanitizeDateTime(i.ReadTime, {zone: 'UTC'}), dtObj))
    })
    groups.forEach((g, index)=>{
      const end = index + 1 < groups.length ? groups[index+1][0] : g[g.length -1]
      consumed (g[0], end)
    })
    const result = groups.map (gr => gr[0])
    return result
  }
  renderTable(rawData, tableId) {
    if (this.state.isLoading)
      return this.state.loader

    if (Array.isArray(rawData) && rawData.length > 0) {
      const disp = this.rollup2 (rawData)
      const cols = this.hiddenColMap (disp)
      const colSeq = this.config.displayOrder.filter ((i, index) => cols[index])
      const colNames = this.config.displayName.filter((i, index) => cols[index])
      return(
        <table className="csv-table" id={tableId}>
        <tbody>
        <TitleRow index={0} data={rawData[0]} colName={colNames} colSeq={colSeq} graph={this.sort} colSort={this.state.colSort}/>
        {disp.map((dev, index) => this.renderRow (dev, index, colSeq) )}
        </tbody>
        </table>
      )
    }
    else return <NoResults />
  }
  renderTableHeader() {
    if (!this.state.modalShow) {
      return (
        <div className="device-header">
          <DevicePanel {...this.props} redirecting={this.redirecting} dcfg={this.state.deviceConfig}/>
          <DeviceStatusPanel {...this.props} dcfg={this.state.deviceConfig}/>
        </div>
      )
    }
    return null;
  }
  render() {
    const rawData = this.state.displayData;
    if (this.state.redirecting) 
      return (<MeteringReport {...this.props} />);
    const dcapTZ = siteTZ(this.props.getActiveSite());
    return (
      <>
        {this.renderTableHeader()}
        <div className="mdt-control-row">
        <div className="date-panel">
          <DatePanel3 {...this.props} propagateState={this.setFilters} tz={dcapTZ} 
            dropDown={this.props.intervalDropDown} />
        </div>
        <div className="device-rollup">
          <Rollup interval={this.state.rollup} onChange={this.onRollup} />
        </div>
        </div>
        <div className="device-buttons">
          <TrendButton {...this.props} onClick={this.toggleTrend} />
          <span className="btnlabel">Compare</span>
          <span className='action-button'>
            <ChartButton {...this.props} chartClick={this.toggleChart} />
          </span>
          <span className="btnlabel">Change View</span>
          {this.renderConditionalButtons()}
        </div>
        <div className="table-container device-tbl">
          {this.state.trendShow ? this.renderTrend(): null}
          {this.state.modalShow ? this.renderChart() : this.renderTable(rawData, this.tableId)}
        </div>
      </>
    )
  }
}
